import React from "react"
import TeamCard from "../../components/TeamCard"
import Header from "../../components/Header"
import Layout from "../../layouts/Layout"
import "../../styles/global.css"

export default function FounderBatch() {
  return (
    <Layout>
      <Header heading="PCCOE&#38;R ACM STUDENT CHAPTER EX-MEMBERS"></Header>
      <div className="teams-container">
        <TeamCard
          name="Ashish Salunke"
          position="Founder"
          source="/ex-acm-members/ashish-salunke.png"
        />
        <TeamCard
          name="Varun Pilakavil"
          position=""
          source="/ex-acm-members/varun-pilakavil.png"
        />
        <TeamCard
          name="Pratik Khedekar"
          position=""
          source="/ex-acm-members/pratik-khedekar.png"
        />
        <TeamCard
          name="Shreyash Pimpalshende"
          position=""
          source="/ex-acm-members/shreyash-pimpalshende.png"
        />
        <TeamCard
          name="Chaitanya Nirhali"
          position=""
          source="/ex-acm-members/chaitanya-nirhali.png"
        />
        <TeamCard
          name="Chetan Pathade"
          position=""
          source="/ex-acm-members/chetan-pathade.png"
        />
        <TeamCard
          name="Krunal Patil"
          position=""
          source="/ex-acm-members/krunal-patil.png"
        />
        <TeamCard
          name="Sudeshna Patil"
          position=""
          source="/ex-acm-members/sudeshna-patil.png"
        />
        <TeamCard
          name="Vishal Sonar"
          position=""
          source="/ex-acm-members/vishal-sonar.png"
        />
      </div>
      <div className="seperator"></div>
    </Layout>
  )
}
